jQuery(document).ready(function ($) {
    // Ensure wpRedirectConfig is available
    if (typeof window.wpRedirectConfig === 'undefined') {
        console.error('wpRedirectConfig is not defined. Popup cannot function.');
        return;
    }

    var jBoxInstance = null; // Keep track of the jBox instance

    // Helper function to create and open the jBox modal
    function openRedirectModal(modalParams) {
        if (jBoxInstance) {
            jBoxInstance.destroy(); // Destroy previous instance if any
            jBoxInstance = null;
        }

        var modalContentHtml = $(wpRedirectConfig.source_content_selector).html(); // Get base HTML
        var countdown = 5;
        var countdownSpan;

        // Determine messages and URLs
        var messageHeading = modalParams.message_heading;
        var messageBody = modalParams.message_body;
        var finalRedirectUrl = modalParams.final_redirect_url;
        var linkUrl = modalParams.link_url || null;
        var linkText = modalParams.link_text || null;

        // Use defaults from wpRedirectConfig if not provided in modalParams (especially for countdown text)
        var countdownPrefix = modalParams.countdown_prefix || wpRedirectConfig.default_countdown_prefix;
        var countdownSuffix = modalParams.countdown_suffix || wpRedirectConfig.default_countdown_suffix;
        var clickHereText = modalParams.click_here_text || wpRedirectConfig.default_click_here_text;

        jBoxInstance = new jBox('Modal', {
            content: modalContentHtml,
            color: 'white', // Temporarily disable
            attributes: { x: 'center', y: 'center' },
            maxWidth: 600,
            addClass: 'custom-redirect-jbox', // Temporarily disable
            closeOnClick: false,
            closeButton: false, // No close button on the jBox frame
            draggable: false,
            overlay: true,
            overlayColor: 'rgba(0, 0, 0, 0.7)',
            onCreated: function () {
                // Populate content using jQuery selectors on 'this.content'
                this.content.find('#redirect-message-heading').html(messageHeading);
                this.content.find('#redirect-message-body').html(messageBody); // Use .html() to render links

                var mainLinkElem = this.content.find('#redirect-main-link');
                if (linkText && linkUrl) {
                    mainLinkElem.attr('href', linkUrl).html(linkText).parent('p').show();
                } else {
                    mainLinkElem.parent('p').hide();
                }

                var countdownParagraph = this.content.find('#redirect-countdown-paragraph');
                var countdownSpanHtml = '<span class="redirect-countdown-span">' + countdown + '</span>';
                // Ensure the "click here" link also uses the finalRedirectUrl
                var countdownLinkHtml = '<a class="redirect-countdown-link" href="' + finalRedirectUrl + '">' + clickHereText + '</a>';

                countdownParagraph.html(countdownPrefix + countdownSpanHtml + countdownSuffix + countdownLinkHtml);
                countdownSpan = this.content.find('.redirect-countdown-span');
            },
            onCloseComplete: function () {
                // This might be called if jBox is closed by other means, good to have.
                if (this.destroy) { // Check if destroy method exists
                    this.destroy();
                }
                jBoxInstance = null;
            },
            onOpen: function () {
                var timer = setInterval(function () {
                    countdown--;
                    if (countdownSpan && countdownSpan.length) {
                        countdownSpan.text(countdown);
                    }
                    if (countdown <= 0) {
                        clearInterval(timer);
                       // window.location.href = finalRedirectUrl;
                    }
                }, 1000);
            }
        });
        jBoxInstance.open();
    }

    // 1. Handle CSV-based redirects (data provided via window.wpRedirectData on the special redirect page)
    if (typeof window.wpRedirectData !== 'undefined' && window.wpRedirectData.final_redirect_url) {
        // wpRedirectData is specific to the CSV redirect page instance
        openRedirectModal({
            message_heading: window.wpRedirectData.message_heading,
            message_body: window.wpRedirectData.message_body,
            link_url: window.wpRedirectData.link_url,
            link_text: window.wpRedirectData.link_text,
            final_redirect_url: window.wpRedirectData.final_redirect_url,
            countdown_prefix: window.wpRedirectData.countdown_prefix,
            countdown_suffix: window.wpRedirectData.countdown_suffix,
            click_here_text: window.wpRedirectData.click_here_text
        });
    }

    // 2. Handle outbound prayerwithbeads.com link clicks
    // Use event delegation for dynamically added content as well.
    $(document).on('click', 'a', function (event) {
        var $link = $(this);
        var clickedUrl = $link.attr('href');

        // Check if the link is an outbound link to prayerwithbeads.com
        if (clickedUrl && clickedUrl.indexOf('kristilynglass.com') !== -1) {
            // Prevent clicks on links within the modal itself from re-triggering
            if ($link.closest('#redirect-popup-content-source').length > 0 || $link.hasClass('redirect-countdown-link')) {
                // If it's the countdown link, let it proceed (it already points to finalRedirectUrl)
                // Otherwise, if it's another link inside the modal, do nothing here to avoid loop.
                return;
            }

            // Prevent default navigation for the outbound link
            event.preventDefault();

            $.ajax({
                url: wpRedirectConfig.ajax_url,
                type: 'POST',
                data: {
                    action: 'klg_check_cart_for_redirect', // Matches the PHP action hook
                    nonce: wpRedirectConfig.nonce,
                    target_url: clickedUrl
                },
                dataType: 'json',
                success: function (response) {
                    if (response.success && response.data) {

                        var ajaxData = response.data;
                        var modalParams = {
                            final_redirect_url: ajaxData.final_redirect_url,
                            link_url: ajaxData.link_url, // Should be null from AJAX
                            link_text: ajaxData.link_text, // Should be null from AJAX
                            // Countdown text will use defaults from wpRedirectConfig
                        };

                        if (ajaxData.has_cart_items) {
                            modalParams.message_heading = wpRedirectConfig.outbound_cart_items_heading;
                            modalParams.message_body = wpRedirectConfig.outbound_cart_items_body;
                        } else {
                            modalParams.message_heading = wpRedirectConfig.outbound_cart_empty_heading;
                            modalParams.message_body = wpRedirectConfig.outbound_cart_empty_body;
                        }
                        openRedirectModal(modalParams);
                    } else {
                        // Fallback: allow the link to proceed normally if AJAX call fails or returns error
                        console.error('AJAX error or unsuccessful response:', response);
                        window.location.href = clickedUrl;
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    // Fallback: allow the link to proceed normally if AJAX errors
                    console.error('AJAX request failed:', textStatus, errorThrown);
                    window.location.href = clickedUrl;
                }
            });
        }
    });
});
